import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { silentRefresh } from "../services/api";
//import LoadingSpinner from "./LoadingSpinner";

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);
  const token = localStorage.getItem("access_token");
  const userRole = localStorage.getItem("user_role");

  useEffect(() => {
    const checkAuth = async () => {
      if (!token) {
        navigate("/login");
        return;
      }

      try {
        const decodedToken = jwtDecode(token);
        const isExpired = decodedToken.exp * 1000 < Date.now();

        if (isExpired) {
          const refreshed = await silentRefresh();
          if (!refreshed) {
            navigate("/login");
            return;
          }
        }

        // Check if user has any of the allowed roles
        if (allowedRoles.length > 0) {
          if (!allowedRoles.includes(userRole)) {
            // If user doesn't have required role, redirect to login with a flag
            navigate("/login", { state: { unauthorized: true } });
            return;
          }
        }
      } catch (error) {
        console.error("Auth check failed:", error);
        navigate("/login");
      } finally {
        setIsChecking(false);
      }
    };

    checkAuth();
  }, [token, userRole, navigate, allowedRoles]);

  if (isChecking) {
    return (
     <div className="fixed top-0 left-0 w-full h-full z-[9999] flex justify-center items-center bg-white bg-opacity-80 backdrop-blur-sm">
         
    <div className="relative w-20 h-20">
         {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
           <span
             key={i}
             className="absolute top-1/2 left-1/2 w-4 h-4 bg-[#0d5a47] rounded-full animate-pop-fade"
             style={{
               "--angle": `${angle}deg`,
 animationDelay: `${i * 200 - 1600}ms`
             }}
           />
         ))}
       </div>
  </div>
    );
  }

  return children;
};

export default PrivateRoute;
